import { supabase } from './supabase';

/**
 * Authenticated fetch wrapper that adds the Supabase JWT token to requests.
 * Use this for all /api/* calls to ensure proper authentication.
 */
export async function authFetch(url, options = {}) {
  // Get the current session
  const { data: { session } } = await supabase?.auth?.getSession() || { data: { session: null } };

  // Debug: log session status
  if (!session?.access_token) {
    console.warn('authFetch: No access token available for', url);
  }

  // Merge headers with auth token
  const headers = {
    ...options.headers,
  };

  // Add Authorization header if we have a session
  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }

  return fetch(url, {
    ...options,
    headers,
  });
}

/**
 * Helper for POST requests with JSON body
 */
export async function authPost(url, body, options = {}) {
  return authFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    body: JSON.stringify(body),
    ...options,
  });
}

/**
 * Helper for GET requests
 */
export async function authGet(url, options = {}) {
  return authFetch(url, {
    method: 'GET',
    ...options,
  });
}

/**
 * Helper for PUT requests with JSON body
 */
export async function authPut(url, body, options = {}) {
  return authFetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    body: JSON.stringify(body),
    ...options,
  });
}
